// extracted by mini-css-extract-plugin
module.exports = {"trigger":"_2Id230M5fUBa"};